<script lang="ts">
export default {
    name: "AlertPop",
};
</script>

<script setup lang="ts">
import { store } from "@/store"
import { onMounted } from "vue"
import JessibucaPlayer from '@/components/jessibuca-player/index.vue'
import { getDeviceTopo1, getLiveCapacityBySn, startLivestream, GetDetectStreamAddr } from "@/api/monitorApi/index"

const props = defineProps({
    alertVisible: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
    sn: {
        type: String,
        default: () => {
            return "";
        },
    },
    deviceSn: {
        type: String,
        default: () => {
            return "";
        },
    }
});

const emits = defineEmits(["update:alertVisible"]);

const closeDialog = () => {
    emits("update:alertVisible", false);
    watchDeviceState()
    watchStatus()
}

const livestreamSource = ref()
const droneList = ref()
const cameraSelectedId = ref()
const videoId = ref()
const livetypeSelected = ref(1)

const onRefresh = async () => {
    await getLiveCapacityBySn(props.sn)
        .then(res => {
            console.log(res)
            console.log('刷新后值改变')
            if (!res.length) {
                console.warn('警告：获取直播容量为空!!!')
                return
            }
            const resData: Array<[]> = res
            livestreamSource.value = resData

            const temp: any = []
            if (livestreamSource.value) {
                livestreamSource.value.forEach((ele: any) => {
                    temp.push({ label: ele.name + '-' + ele.sn, value: ele.sn, more: ele.cameras_list, domain: ele.domain })
                })
                droneList.value = temp
            }
            onStart()
        })
}
const uavStatus = ref(null)
const videoUrl = ref()
const onStart = async () => {
    console.log('值改变')
    let liveURL = ''
    uavStatus.value = null
    //当有无人机的时候判断无人机是否为起飞状态如果是就切换到无人机画面 如果不是就切换到机场画面
    if (droneList.value.length > 1) {
        let lensList
        var uavObj = droneList.value.find((item: any) => item.domain == 0);
        console.log(uavObj)
        if (uavObj.more[1]) {
            lensList = uavObj.more[1]
        } else {
            lensList = uavObj.more[0]
        }
        cameraSelectedId.value = lensList.id
        videoId.value = uavObj.value + '/' + lensList.index + '/' + lensList.videos_list[0].index
    } else {
        var airportObj = droneList.value.find((item: any) => item.domain == 3);
        cameraSelectedId.value = airportObj.more[0].id
        videoId.value = airportObj.value + '/' + airportObj.more[0].index + '/' + airportObj.more[0].videos_list[0].index
    }
    liveURL = import.meta.env.VITE_APP_RTMP_URL + cameraSelectedId.value
    await startLivestream({
        url: liveURL,
        video_id: videoId.value,
        url_type: livetypeSelected.value,
        video_quality: 0
    })
        .then(res => {
            let url = res.http_url
            videoUrl.value = url
        })
        .catch(err => {
            console.error(err)
        })
}


// 无人机状态
// const deviceInfo1 = computed(() => store.other.useMyStore().getDeviceStatus)
const eventActive = ref()
const status = ref()
let watchDeviceState: any
let watchStatus: any

const handleDialogOpen = async () => {
    await onRefresh()
    watchDeviceState = watch(() => store.other.useMyStore().getDeviceStatus, (newVal, oldVal) => {
        // console.log(props.deviceSn)
        // console.log(newVal)
        // if (Object.keys(newVal).length) {
        //     console.log(newVal[props.deviceSn])
        // }
        // if (oldVal && Object.keys(oldVal).length) {
        //     console.log(oldVal[props.deviceSn])
        // }
        if (Object.keys(newVal).length && oldVal && Object.keys(oldVal).length) {
            eventActive.value = newVal[props.deviceSn].mode_code
            if (newVal[props.deviceSn]?.mode_code !== oldVal[props.deviceSn]?.mode_code) {
                if (newVal[props.deviceSn].mode_code == 0) {
                    status.value = 0
                } else if (newVal[props.deviceSn].mode_code == 5) {
                    status.value = 1

                }
            }
        }
    }, {
        deep: true,
        immediate: true
    })

    watchStatus = watch(status, async (newVal, oldVal) => {
        console.log(newVal, oldVal)
        if (newVal != oldVal) {
            if (newVal == 1) {
                console.log("状态改变为1")
                await onRefresh()
            } else {
                console.log("状态改变为0")
                await onRefresh()
            }
        }
    }, {
        deep: true,
    })
}


</script>

<template>
    <el-dialog class="alert-box" @open="handleDialogOpen" v-model="props.alertVisible" title="实时视频："
        @close="closeDialog" draggable>
        <div class="videoBox">
            <jessibuca-player :url="videoUrl"></jessibuca-player>
        </div>
    </el-dialog>
</template>

<style lang="scss">
.alert-box {
    width: 35vw;
    height: 45vh;
    background: url("@/assets/images/small-pop.png") no-repeat center;
    background-size: 100% 100%;

    .el-dialog__title {
        color: #fff;
    }

    .videoBox {
        width: 33vw;
        height: 37vh;
        margin: .625rem auto;
    }
}
</style>